var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingleUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42796 6.60496C8.16521 6.60496 9.57318 5.12658 9.57318 3.30248C9.57318 1.47838 8.16521 0 6.42796 0C4.69072 0 3.28274 1.47838 3.28274 3.30248C3.28274 5.12658 4.69072 6.60496 6.42796 6.60496ZM8.62962 7.43058H8.21926C7.67377 7.69375 7.06684 7.84339 6.42796 7.84339C5.78909 7.84339 5.18462 7.69375 4.63666 7.43058H4.22631C2.40306 7.43058 0.923828 8.98378 0.923828 10.8982V11.9715C0.923828 12.6552 5.33746 14 5.98862 14H7.2017C7.85286 14 11.9321 12.6552 11.9321 11.9715V10.8982C11.9321 8.98378 10.4529 7.43058 8.62962 7.43058Z",
    fill: "#757A88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleUser);
export default __webpack_public_path__ + "static/media/single_user.08281bf8e90b14c56330875eaf94b006.svg";
export { ForwardRef as ReactComponent };